module.exports = __webpack_public_path__ + "static/media/BoyNeonXRosa_GraceBeck-15.831e1223.JPG";